export const toCamel = (s) => s.replace(/([-_][a-z])/ig, ($1) => $1.toUpperCase()
    .replace('-', '')
    .replace('_', ''));
export const toSnake = (s) => {
    if (s === s.toUpperCase())
        return s;
    return s.replace(/[A-Z]/g, (m) => `_${m.toLowerCase()}`);
};
const isArray = (a) => Array.isArray(a);
const isObject = (o) => o === Object(o) && !isArray(o) && typeof o !== 'function';
export const keysToCamel = (o) => {
    if (isObject(o)) {
        const n = {};
        Object.keys(o)
            .forEach((k) => {
            n[toCamel(k)] = keysToCamel(o[k]);
        });
        return n;
    }
    if (isArray(o)) {
        return o.map((i) => keysToCamel(i));
    }
    return o;
};
export const keysToSnake = (o) => {
    if (isObject(o)) {
        const n = {};
        Object.keys(o)
            .forEach((k) => {
            n[toSnake(k)] = keysToSnake(o[k]);
        });
        return n;
    }
    if (isArray(o)) {
        return o.map((i) => keysToSnake(i));
    }
    return o;
};
export const capitalize = (str) => `${str[0].toUpperCase()}${str.slice(1)}`;
